import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import logger from "./lib/logger";

// Sentry — initialised only when REACT_APP_SENTRY_DSN is set at build time.
// Gated via dynamic import so the bundle stays clean when Sentry is disabled.
if (process.env.REACT_APP_SENTRY_DSN) {
  import("@sentry/react").then((Sentry) => {
    Sentry.init({
      dsn: process.env.REACT_APP_SENTRY_DSN,
      environment: process.env.NODE_ENV,
      release: process.env.REACT_APP_SENTRY_RELEASE,
      tracesSampleRate: parseFloat(process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE || "0.1"),
      // Don't send default PII (IP, cookies). Flip on per-event if ever needed.
      sendDefaultPii: false,
    });
  }).catch((err) => {
    // Silent — Sentry is non-critical. Log to console so install issues show up.
    // eslint-disable-next-line no-console
    logger.warn("Sentry failed to load:", err);
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
